module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_14-61ef83d4dbb04a7faef44e5f7a31e6aa.png";